import axios from "axios";
import { del, get, post, patch,  put } from "./course_units_api_helper";
import * as url from "./course_units_url_helper";





// Get features
export const getCourseUnits = () => get(url.GET_COURSE_UNITS);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewSubject = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewCourseUnit = courseUnit =>
  post(url.ADD_NEW_COURSE_UNIT, courseUnit, {
    headers: { "Content-Type": "application/json" }
  });



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateCourseUnit = courseUnit => patch(`${url.UPDATE_COURSE_UNIT}/${courseUnit.id}`,  courseUnit);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteCourseUnit = courseUnit => del(`${url.DELETE_COURSE_UNIT}/${courseUnit.id}`);







export {
  //getLoggedInUser,
  
  
};
